__turbopack_context__.v({
  "h2Caption": "StyleConstants-module__5rEH3q__h2Caption",
  "h2LG": "StyleConstants-module__5rEH3q__h2LG",
  "iPlayfair": "StyleConstants-module__5rEH3q__iPlayfair",
  "linkButton": "StyleConstants-module__5rEH3q__linkButton",
  "main": "StyleConstants-module__5rEH3q__main",
  "underlineBtn": "StyleConstants-module__5rEH3q__underlineBtn",
  "underlineBtnAfter": "StyleConstants-module__5rEH3q__underlineBtnAfter",
  "underlineBtnBefore": "StyleConstants-module__5rEH3q__underlineBtnBefore",
});
